import { Link } from 'expo-router';
import { ComponentPropsWithoutRef } from 'react';

import {
  HeaderFrame,
  HeaderIconButton,
  HeaderTitleText,
  IconChevronLeft,
  IconClose,
  tokens,
} from '@fhs/ui';

type GetScreenTitleHeaderOptions = {
  backStyle?: 'back' | 'close' | 'dynamic';
  testID?: string;
  cannotGoBackHref?: ComponentPropsWithoutRef<typeof Link>['href'];
  shouldBackToRoot?: boolean;
  showDivider?: boolean;
};
export const getScreenTitleHeader =
  (getScreenTitleHeaderOpts?: GetScreenTitleHeaderOptions) =>
  ({
    options,
    navigation,
  }: {
    options: { title?: string };
    navigation: { canGoBack: () => boolean };
  }) => {
    const {
      backStyle = 'dynamic',
      cannotGoBackHref = '/',
      testID,
      shouldBackToRoot = false,
      showDivider = false,
    } = getScreenTitleHeaderOpts ?? {};
    const canGoBack = navigation.canGoBack();
    const href = canGoBack && !shouldBackToRoot ? '../' : cannotGoBackHref;
    const icon =
      (backStyle === 'dynamic' && canGoBack) || backStyle === 'back' ? (
        <IconChevronLeft testID={testID} />
      ) : (
        <IconClose testID={testID} />
      );

    return (
      <HeaderFrame
        style={{
          borderBottomWidth: showDivider ? 1 : 0,
          borderColor: tokens.colors.$blackOpacity10,
        }}
      >
        <HeaderFrame.Left>
          <Link href={href} asChild dismissTo>
            <HeaderIconButton aria-label="Go back">{icon}</HeaderIconButton>
          </Link>
        </HeaderFrame.Left>
        <HeaderFrame.Middle>
          <HeaderTitleText text={options.title} />
        </HeaderFrame.Middle>
        <HeaderFrame.Right />
      </HeaderFrame>
    );
  };
